import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectStyles } from 'injectStyles';
import FaqCategory from 'components/FaqCategory';

class FaqCategoryList extends PureComponent {
  static defaultProps = {
    categories: null,
    current: null,
    slug: null,
    showAnswers: false,
    showQuestions: false,
  };

  static propTypes = {
    categories: PropTypes.array,
    current: PropTypes.string,
    classes: PropTypes.object.isRequired,
    showAnswers: PropTypes.bool,
    showQuestions: PropTypes.bool,
    slug: PropTypes.string,
  };

  render() {
    const { categories, classes } = this.props;

    return (
      <div className={classes.categories}>
        {categories && categories.map(({ id, ...fields }) => <FaqCategory key={id} {...this.props} {...fields} />)}
      </div>
    );
  }
}

const styles = {
  categories: {
    marginTop: 20,
  },
};

export default injectStyles(styles)(FaqCategoryList);
